"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flattenNodes;
exports.hasProps = hasProps;
var _react = require("react");
var _reactIs = require("react-is");
/*
  Similar to React's built-in Children.toArray method, this utility takes children and returns them as an array for
  introspection or filtering. Different from Children.toArray, it will flatten arrays and React.Fragments into a
  regular, one-dimensional array while ensuring element and fragment keys are preserved, unique, and stable between renders.
*/

// typeguard to check for props in a ReactChild
function hasProps(child) {
  return child.props !== undefined;
}
function flattenNodes(children, depth = 0, keys = []) {
  return _react.Children.toArray(children).reduce((acc, node, nodeIndex) => {
    if ((0, _reactIs.isFragment)(node)) {
      var _node$key;
      return [...acc, ...flattenNodes(node.props.children, depth + 1, keys.concat((_node$key = node.key) !== null && _node$key !== void 0 ? _node$key : nodeIndex))];
    }
    if ( /*#__PURE__*/(0, _react.isValidElement)(node)) {
      return [...acc, /*#__PURE__*/(0, _react.cloneElement)(node, {
        key: keys.concat(String(node.key)).join('.')
      })];
    }
    if (typeof node === 'string' || typeof node === 'number') {
      return [...acc, node];
    }
    return acc;
  }, []);
}